<template>
  <div class="wrapper">
    <div class="thumbnail-container" v-show="displayPreview">
      <div class="thumbnail">
        <iframe
          class="iframe"
          :src="previewIframeSrc"
          frameborder="0"
          ref="iframe"
        />
      </div>
    </div>
    <div class="preview-text">
      <strong>{{ widgetLabel }}</strong
      ><br />
      <small>{{ typeLabel }}</small>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      displayPreview: false,
      iframeLoaded: false
    }
  },
  props: {
    previewContent: Object,
    widget: Object
  },
  computed: {
    previewIframeSrc() {
      const FRONTEND_URL = process.env.VUE_APP_FRONTEND_URL
      return `${FRONTEND_URL}/podglad/widget`
    },
    widgetLabel() {
      return this.widget.working_name || this.widget.title || 'Widget bez nazwy'
    },
    typeLabel() {
      const resourcetype = this.widget.resourcetype
      const findByResourcetype = type => type.resourcetype === resourcetype
      const widget = this.$store.state.widgetTypes.find(findByResourcetype)
      const label = widget && widget.label
      return label || resourcetype
    }
  },
  created() {
    window.addEventListener('message', this.messageFromIframeHandler)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('message', this.messageFromIframeHandler)
    })
  },
  methods: {
    messageFromIframeHandler(event) {
      const iframeLoaded =
        this.$refs.iframe && event.source === this.$refs.iframe.contentWindow
      if (iframeLoaded) {
        this.iframeLoaded = true
        this.postIframeMessage()
      }
    },
    postIframeMessage() {
      if (this.previewContent && this.iframeLoaded) {
        this.$refs.iframe &&
          this.$refs.iframe.contentWindow.postMessage(this.previewContent, '*')
        this.displayPreview = true
      } else {
        this.displayPreview = false
      }
    }
  },
  watch: {
    previewContent(value) {
      this.postIframeMessage()
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  align-items: center;
}

/* https://medium.com/@jamesfuthey/simulating-the-creation-of-website-thumbnail-screenshots-using-iframes-7145269891db */
$thumbnail-width: 1440px;
$thumbnail-height: 600px;
$thumbnail-zoom: 0.25;

/* This container helps the thumbnail behave as if it were an unscaled IMG element */
.thumbnail-container {
  width: calc(#{$thumbnail-width} * #{$thumbnail-zoom});
  height: calc(#{$thumbnail-height} * #{$thumbnail-zoom});
  display: inline-block;
  overflow: hidden;
  position: relative;
  background: #f9f9f9;
}

/* This is a masking container for the zoomed iframe element */
.thumbnail {
  -ms-zoom: $thumbnail-zoom;
  -moz-transform: scale($thumbnail-zoom);
  -moz-transform-origin: 0 0;
  -o-transform: scale($thumbnail-zoom);
  -o-transform-origin: 0 0;
  -webkit-transform: scale($thumbnail-zoom);
  -webkit-transform-origin: 0 0;
}

/* This is our screen sizing */
.thumbnail,
.thumbnail iframe {
  width: $thumbnail-width;
  height: $thumbnail-height;
}

/* This pseudo element masks the iframe, so that mouse wheel scrolling and clicking do not affect the simulated "screenshot" */
.thumbnail:after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.preview-text {
  margin-left: 25px;
}
</style>
